import Card from 'components/Card';
import { DataForm, InputMask } from 'components/formik_inputs';
import PercentageInput from 'components/formik_inputs/custom-inputs/PercentageInput';
import React, { useCallback, useEffect, useState } from 'react';
import InputSelect from 'components/formik_inputs/InputSelect';
import Button from 'components/common/buttons/Button';
import {
  createTermYear,
  editTermYear,
  getTermYear,
  deleteTermYear,
} from '../../services/academic';
import { useHistory, useParams } from 'react-router';
import DynamicSelect from 'components/formik_inputs/custom-inputs/DynamicSelect';
import { fetchTerms } from '../../services/options_services';
import { nativeGet as get, parsePercentageFieldValue } from 'utils';
import ButtonWithConfirmation from 'components/common/buttons/ButtonWithConfirmation';
import { PermissionContext } from 'hoc/withPermission';
import { toast } from 'react-toastify';
import { createNumberMask } from 'text-mask-addons';

const TermYearForm = ({ ...props }) => {
  const { id } = useParams();
  const history = useHistory();
  const edit = window.location.pathname.includes('edit');

  const [initialData, setInitialData] = useState({});

  useEffect(() => {
    if (id) {
      getTermYear(id).then((data) =>
        setInitialData({
          ...data,
          number: TermYearNumberOptions.find((op) => op.value === data?.number),
          offer: { label: data?.offer, value: data?.offer },
          term: {
            label: `${data?.term?.course_offer?.course} - ${data.term?.name} - ${data.term?.course_offer?.offer_type}`,
            value: data?.term?.id,
          },
        })
      );
    }
  }, [id]);

  const save = async (values) => {
    const data = {
      ...values,
      number: values?.number?.value,
      term: values?.term?.value,
      offer: values?.offer?.label,
      approval_percentage: parsePercentageFieldValue(
        values?.approval_percentage
      ),
      min_average: parsePercentageFieldValue(values?.min_average),
      retake_percentage: parsePercentageFieldValue(values?.retake_percentage),
      min_attendance: parsePercentageFieldValue(values?.min_attendance),
      max_grade_after_retake: values?.max_grade_after_retake,
    };

    if (edit) {
      await editTermYear(data).then((res) => history.push('/etapas/anos'));
    } else {
      await createTermYear(data).then((res) => history.push('/etapas/anos'));
    }
  };

  const handleDelete = useCallback(async () => {
    try {
      await deleteTermYear(id);

      toast.success('Etapa x Ano excluída com sucesso.');
      history.push('/etapas/anos');
    } catch (err) {
      const error = get(err, 'response.data.detail', '');
      toast.error(error || 'Ocorreu um erro ao remover a Etapa x Ano.');
    }
  }, [id]);

  return (
    <Card title="Cadastrar nova Etapa x Ano">
      <DataForm
        initialValues={edit ? initialData : initialValues}
        onSubmit={save}
        autoSetErrors
        enableReinitialize
      >
        <div style={formStyle}>
          <DynamicSelect
            label="Etapa"
            name="term"
            fetchFunction={fetchTerms}
            getOptionValue={(d) => d.value}
            getOptionLabel={(d) => d.label}
            required
          />
          <InputMask
            mask={[/\d/, /\d/, /\d/, /\d/]}
            label="Ano"
            placeholder="XXXX"
            name="year"
            required
          />
          <InputSelect
            required
            name="number"
            label="Semestre"
            options={TermYearNumberOptions}
          />
          <PercentageInput
            label="Porcentagem de aprovação"
            placeholder="0% - 100%"
            name="approval_percentage"
          />
          <PercentageInput
            label="Média Mínima"
            placeholder="0% - 100%"
            name="min_average"
          />
          <PercentageInput
            label="Porcentagem de recuperação"
            placeholder="0% - 100%"
            name="retake_percentage"
          />
          <PercentageInput
            label="Frequência mínima"
            placeholder="0% - 100%"
            name="min_attendance"
          />
          <InputMask
            label="Nota máxima após recuperação"
            name="max_grade_after_retake"
            required
            placeholder="0 - 100"
            mask={createNumberMask({
              prefix: '',
              suffix: '',
              decimalSymbol: ',',
              allowDecimal: true,
              includeThousandsSeparator: false,
              decimalLimit: 2,
              integerLimit: 3,
            })}
          />
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '20px',
          }}
        >
          <Button onClick={() => history.push('/etapas/anos')}>Voltar</Button>
          <div>
            <PermissionContext.Consumer>
              {({ hasPermission }) =>
                hasPermission('academico.delete_termyear') &&
                edit && (
                  <ButtonWithConfirmation
                    action="danger"
                    confirmationText="Deseja excluir permanentemente essa Etapa x Ano ?"
                    onClick={handleDelete}
                  >
                    Excluir
                  </ButtonWithConfirmation>
                )
              }
            </PermissionContext.Consumer>
            <Button type="submit">Salvar</Button>
          </div>
        </div>
      </DataForm>
    </Card>
  );
};

export default TermYearForm;

const TermYearNumberOptions = [
  { label: 'Anual', value: 0 },
  { label: 'Primeiro', value: 1 },
  { label: 'Segundo', value: 2 },
];

const formStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridTemplateRows: '1fr 1fr 1fr',
  gap: '30px',
  padding: '12px',
};

const initialValues = {
  year: '',
  semester: '',
  approval_percentage: '',
  min_average: '',
  retake_percentage: '',
  min_attendance: '',
  max_grade_after_retake: '',
  close_discipline: false,
  offer: '',
};
